/* Star Kagune — Mini-Figures Upsell Modal
   Triggers on ATC for any product in the mini-figures collection.
   Shows a full-screen modal (mobile) / centered card (desktop) before
   adding to cart, then batch-adds original + selected upsells in one
   request so UpCart drawer only opens once. */
(function () {
  'use strict';

  // Toggle by setting localStorage.sk_upsell_debug = '1' for on-page debug bar
  var DEBUG = false;
  try { DEBUG = localStorage.getItem('sk_upsell_debug') === '1'; } catch (e) {}
  var debugBanner = null;
  function ensureBanner() {
    if (!DEBUG) return null;
    if (debugBanner) return debugBanner;
    if (!document.body) return null;
    debugBanner = document.createElement('div');
    debugBanner.id = 'sk-upsell-debug';
    debugBanner.style.cssText = 'position:fixed;bottom:0;left:0;right:0;background:#000;color:#0f0;font:12px/1.4 monospace;padding:8px 12px;z-index:999999;max-height:30vh;overflow:auto;white-space:pre-wrap;border-top:2px solid #0f0;';
    debugBanner.innerHTML = '<b>[sk-upsell debug]</b> <span style="color:#fff;float:right;cursor:pointer" onclick="this.parentNode.remove()">×</span><br>';
    document.body.appendChild(debugBanner);
    return debugBanner;
  }
  function log() {
    var args = [].slice.call(arguments);
    try { console.log.apply(console, ['[sk-upsell]'].concat(args)); } catch (e) {}
    if (DEBUG) {
      var b = ensureBanner();
      if (b) {
        var msg = args.map(function (a) { try { return typeof a === 'string' ? a : JSON.stringify(a); } catch (e) { return String(a); } }).join(' ');
        b.innerHTML += '[sk-upsell] ' + msg + '<br>';
      }
    }
  }

  var MF_HANDLES =["ainz-ooal-gown-mini-figures","aot-titan-giant-custom-figure-pre-order","aot-titans-giant-custom-figure","attack-on-titan-mini-figures","beast-titan-giant-custom-figure","berserk-mini-figures","berserk-skull-knight-mini-figures","berserk-v2-mini-figure-pre-order","bleach-mini-figures","blood-moon-mini-figures","chainsaw-man-mini-figures","chainsaw-rampage-brick-diorama","colossal-titan-giant-custom-figure","death-note-mini-figures","delicious-in-dungeon-mini-figures-pre-order","demon-hunters-mini-figures","demon-slayer-mini-figures","dragon-ball-mini-figures","dragon-ball-mini-figures-vol-2-0","dragon-ball-xeno-mini-figures","dragon-ball-z-fighters-mini-figures","fazbear-frights-mini-figures","flex-minifigure","frieren-mini-figures","galactus-giant-figures","gundam-mini-figures","gundamm-mini-figures","hunterxhunter-mini-figures-hxh","inuyasha-mini-figures","jojos-bizarre-mini-figures","jujutsu-kaisen-mini-figures","kaiju-no-8-mini-figures","lich-king-mini-figure","marvel-mini-figures","mini-figures","mystery-mini-figure-1","naruto-mini-figures","naruto-mini-figures-vol-2-0","neon-genesis-evangelion-mini-figures","occult-x-alien-mini-figures","one-piece-mini-figures","one-piece-mini-figures-vol-2-0","world-powers-collection-one-piece-mini-figures","one-punch-man-mini-figures","pokemon-mini-figures","sailor-moon-mini-figures","simpsons-mini-figures","skeletal-susanoo-evolution-figures","slam-dunk-mini-figures","solo-leveling-mini-figures","spooky-curse-mini-figures","spy-family-mini-figures","stitch-mini-figures","susanoo-ninjas-mini-figures","tokyo-ghoul-mini-figures","yuyu-hakusho-mini-figures","zootopia-mini-figures-pre-order"];
  var MF_HANDLES_SET = MF_HANDLES.reduce(function (s, h) { s[h] = 1; return s; }, {});

  var KS_HANDLES = ["attack-on-titan-embroidered-keychains","aura-farmers-embroidered-keychains","berserk-embroidered-keychains","black-clover-embroidered-keychains","bleach-embroidered-keychains","blue-lock-embroidered-keychains","chainsaw-man-embroidered-keychains","death-note-embroidered-keychains","demon-slayer-embroidered-keychains","dr-stone-embroidered-keychains","dragon-ball-embroidered-keychains","ghibli-embroidered-keychains","hunter-x-hunter-embroidered-keychains","jojos-bizarre-embroidered-keychains","jujutsu-kaisen-embroidered-keychains","midnite-whispers-embroidered-keychains","my-hero-academia-embroidered-keychains","naruto-embroidered-keychains","neon-genesis-evangelion-embroidered-keychains","one-piece-embroidered-keychains","pokemon-embroidered-keychains","seven-deadly-sins-embroidered-keychains","solo-leveling-embroidered-keychains","the-musketeers-embroidered-keychains","tokyo-ghoul-embroidered-keychains","twin-flame-keychain-set"];
  var KS_HANDLES_SET = KS_HANDLES.reduce(function (s, h) { s[h] = 1; return s; }, {});

  var UPSELLS = {
    carabiner: { handle: 'clip-carry-carabiner' },
    flex: { handle: 'flex-mini-figures' },
    keychain: { handle: 'twin-flame-keychain-set' }
  };
  var UPSELL_HANDLES_SET = { 'clip-carry-carabiner': 1, 'flex-mini-figures': 1, 'twin-flame-keychain-set': 1 };

  // Dismiss flag is keyed on the offer signature (sorted upsell handles) so a different
  // offer type re-triggers the modal even if user dismissed a previous one this session.
  var DISMISS_PREFIX = '__sk_upsell_dismissed_v2__';
  function offerSignature(picks) {
    return picks.map(function (p) { return p.handle; }).sort().join(',');
  }
  function isDismissed(sig) {
    try { return sessionStorage.getItem(DISMISS_PREFIX + sig) === '1'; } catch (e) { return false; }
  }
  function markDismissed(sig) {
    try { sessionStorage.setItem(DISMISS_PREFIX + sig, '1'); } catch (e) {}
  }
  var productCache = {};

  // -------- helpers --------
  function getCurrentHandle() {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : null;
  }

  // Current product's type, read synchronously from the page (no fetch needed).
  function currentPageType() {
    try {
      var t = window.ShopifyAnalytics && window.ShopifyAnalytics.meta &&
              window.ShopifyAnalytics.meta.product && window.ShopifyAnalytics.meta.product.type;
      if (t) return t;
      return (window.meta && window.meta.product && window.meta.product.type) || "";
    } catch (e) { return ""; }
  }

  // Current product's collection handles, injected by theme.liquid via:
  //   window.__SK_PRODUCT_COLLECTIONS = {{ product.collections | map: 'handle' | json }}
  // This is the PRIMARY trigger signal — manage the "mini-figures" / "key-straps"
  // collections in Shopify admin and the modal follows automatically, no code edits.
  function productCollections() {
    try {
      var c = window.__SK_PRODUCT_COLLECTIONS;
      return (c && c.length) ? c : [];
    } catch (e) { return []; }
  }
  function inCollection(handle) {
    var cols = productCollections();
    for (var i = 0; i < cols.length; i++) { if (cols[i] === handle) return true; }
    return false;
  }

  function isMiniFigurePage() {
    var h = getCurrentHandle();
    // Primary: membership in the curated "mini-figures" collection.
    // Fallbacks (kept so nothing regresses): legacy handle list OR product type.
    return !!(inCollection('mini-figures') || (h && MF_HANDLES_SET[h]) || currentPageType() === "Mini Figure");
  }
  function isKeyStrapPage() {
    var h = getCurrentHandle();
    // Primary: membership in the curated "key-straps" collection.
    // Fallbacks: legacy handle list OR product type "Key Strap".
    return !!(inCollection('key-straps') || (h && KS_HANDLES_SET[h]) || currentPageType() === "Key Strap");
  }
  function isTriggerPage() {
    return isMiniFigurePage() || isKeyStrapPage();
  }

  function isUpsellHandle(h) { return !!UPSELL_HANDLES_SET[h]; }

  function fetchProduct(handle) {
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    return fetch('/products/' + handle + '.js').then(function (r) { return r.json(); })
      .then(function (data) { productCache[handle] = data; return data; });
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  function isKeychainVariant(variant) {
    if (!variant) return false;
    var fields = [variant.title || '', variant.option1 || '', variant.option2 || '', variant.option3 || ''];
    return fields.some(function (f) { return /keychain/i.test(String(f)); });
  }

  function money(cents) {
    var dollars = (cents / 100);
    return '$' + dollars.toFixed(dollars % 1 === 0 ? 0 : 2);
  }

  // Serialize form properties[...] into a clean object
  function getFormProperties(form) {
    var props = {};
    form.querySelectorAll('[name^="properties["]').forEach(function (el) {
      var m = el.name.match(/^properties\[(.+)\]$/);
      if (!m) return;
      if (el.type === 'checkbox' && !el.checked) return;
      if (el.type === 'radio' && !el.checked) return;
      props[m[1]] = el.value;
    });
    return Object.keys(props).length ? props : null;
  }

  // -------- modal --------
  var modal = null;

  function injectModalShell() {
    if (modal) return modal;
    modal = document.createElement('div');
    modal.id = 'sk-upsell-modal';
    modal.setAttribute('aria-hidden', 'true');
    modal.innerHTML = [
      '<div class="sk-upsell-overlay" data-sk-close></div>',
      '<div class="sk-upsell-card" role="dialog" aria-modal="true" aria-labelledby="sk-upsell-title">',
        '<button class="sk-upsell-close" type="button" aria-label="Close" data-sk-close>&times;</button>',
        '<h2 id="sk-upsell-title" class="sk-upsell-headline">Wait! Complete your set</h2>',
        '<p class="sk-upsell-sub">The finishing touches that make it yours</p>',
        '<div class="sk-upsell-cards"></div>',
        '<button class="sk-upsell-cta" type="button">Add selected to cart</button>',
        '<button class="sk-upsell-skip" type="button" data-sk-close>No thanks, just my item</button>',
      '</div>'
    ].join('');
    document.body.appendChild(modal);

    modal.addEventListener('click', function (e) {
      if (e.target.matches('[data-sk-close]')) closeModal();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('sk-upsell-open')) closeModal();
    });
    return modal;
  }

  function variantImage(v, product) {
    if (v.featured_image && v.featured_image.src) return v.featured_image.src;
    if (v.featured_media && v.featured_media.preview_image && v.featured_media.preview_image.src) return v.featured_media.preview_image.src;
    return product.featured_image || (product.images && product.images[0]) || '';
  }

  function buildCardHTML(product, key) {
    var available = product.variants.filter(function (v) { return v.available; });
    if (!available.length) available = product.variants;
    var first = available[0];
    var firstImg = variantImage(first, product);

    var hasDiscount = first.compare_at_price && first.compare_at_price > first.price;
    var compareStrike = hasDiscount ? '<s class="sk-upsell-compare">' + money(first.compare_at_price) + '</s> ' : '';
    var savePct = hasDiscount ? Math.round((first.compare_at_price - first.price) / first.compare_at_price * 100) : 0;
    var saveBadge = hasDiscount ? '<span class="sk-upsell-save">SAVE ' + savePct + '%</span>' : '<span class="sk-upsell-save" style="display:none"></span>';

    var swatchesHtml = available.map(function (v, i) {
      var img = variantImage(v, product);
      var label = (v.title || ('#' + v.id)).replace(/"/g, '&quot;');
      var sel = i === 0 ? ' sk-upsell-swatch--active' : '';
      return '<button type="button" class="sk-upsell-swatch' + sel + '" data-variant-id="' + v.id +
        '" data-price="' + v.price +
        '" data-compare="' + (v.compare_at_price || 0) +
        '" data-image="' + img +
        '" data-label="' + label + '" title="' + label + '" aria-label="' + label + '">' +
        '<img src="' + img + '" alt="' + label + '" loading="lazy">' +
        '</button>';
    }).join('');

    return [
      '<div class="sk-upsell-item" data-upsell-key="' + key + '" data-product-id="' + product.id + '" data-selected-variant="' + first.id + '">',
        '<div class="sk-upsell-top">',
          '<div class="sk-upsell-img"><img class="sk-upsell-img-current" src="' + firstImg + '" alt="' + (product.title || '').replace(/"/g, '&quot;') + '" loading="lazy"></div>',
          '<div class="sk-upsell-info">',
            '<div class="sk-upsell-name">' + product.title + '</div>',
            '<div class="sk-upsell-variant-label">' + (first.title || '') + '</div>',
            '<div class="sk-upsell-price"><strong class="sk-upsell-price-now">' + money(first.price) + '</strong>' + compareStrike + saveBadge + '</div>',
            '<label class="sk-upsell-pick"><input type="checkbox" class="sk-upsell-checkbox" checked> Add this to my order</label>',
          '</div>',
        '</div>',
        (available.length > 1 ? '<div class="sk-upsell-swatches">' + swatchesHtml + '</div>' : ''),
      '</div>'
    ].join('');
  }

  function openModal() {
    injectModalShell();
    document.body.classList.add('sk-upsell-locked');
    modal.classList.add('sk-upsell-open');
    modal.setAttribute('aria-hidden', 'false');
  }

  function closeModal() {
    if (!modal) return;
    document.body.classList.remove('sk-upsell-locked');
    modal.classList.remove('sk-upsell-open');
    modal.setAttribute('aria-hidden', 'true');
  }

  // Wire swatch clicks → update selected variant, image, price, label
  function wireSwatchClicks() {
    if (!modal) return;
    modal.querySelectorAll('.sk-upsell-swatch').forEach(function (sw) {
      if (sw.dataset.skWired) return;
      sw.dataset.skWired = '1';
      sw.addEventListener('click', function () {
        var item = sw.closest('.sk-upsell-item');
        if (!item) return;
        item.querySelectorAll('.sk-upsell-swatch').forEach(function (s) { s.classList.remove('sk-upsell-swatch--active'); });
        sw.classList.add('sk-upsell-swatch--active');
        item.dataset.selectedVariant = sw.dataset.variantId;
        var imgEl = item.querySelector('.sk-upsell-img-current');
        if (imgEl) imgEl.src = sw.dataset.image;
        var priceEl = item.querySelector('.sk-upsell-price-now');
        if (priceEl) priceEl.textContent = money(parseInt(sw.dataset.price, 10) || 0);
        var compareEl = item.querySelector('.sk-upsell-compare');
        var saveEl = item.querySelector('.sk-upsell-save');
        var compare = parseInt(sw.dataset.compare, 10) || 0;
        var price = parseInt(sw.dataset.price, 10) || 0;
        if (compareEl) {
          if (compare > price) {
            compareEl.textContent = money(compare);
            compareEl.style.display = '';
          } else {
            compareEl.style.display = 'none';
          }
        }
        if (saveEl) {
          if (compare > price) {
            saveEl.textContent = 'SAVE ' + Math.round((compare - price) / compare * 100) + '%';
            saveEl.style.display = '';
          } else {
            saveEl.style.display = 'none';
          }
        }
        var labelEl = item.querySelector('.sk-upsell-variant-label');
        if (labelEl) labelEl.textContent = sw.dataset.label;
      });
    });
  }

  // -------- main flow --------
  // Rules:
  //  - Mini-figures product page → show Flex + Twin Flame Keychain (both)
  //  - Key-straps product page  → show Twin Flame Keychain only
  function decideUpsells(addedVariantId, currentProduct) {
    return fetchCart().then(function (cart) {
      var inCart = {};
      cart.items.forEach(function (it) { inCart[it.handle] = true; });

      var onMiniFigPage = inCollection('mini-figures') || MF_HANDLES_SET[currentProduct.handle] || currentProduct.type === "Mini Figure";
      var onKeyStrapPage = inCollection('key-straps') || KS_HANDLES_SET[currentProduct.handle] || currentProduct.type === "Key Strap";

      var picks = [];
      // Clip & Carry Carabiner shows on BOTH mini-figures and key-straps pages — FIRST (top of modal)
      if ((onMiniFigPage || onKeyStrapPage)
          && currentProduct.handle !== UPSELLS.carabiner.handle
          && !inCart[UPSELLS.carabiner.handle]) {
        picks.push({ key: 'carabiner', handle: UPSELLS.carabiner.handle });
      }
      // Twin Flame Keychain shows on BOTH mini-figures and key-straps pages
      if ((onMiniFigPage || onKeyStrapPage)
          && currentProduct.handle !== UPSELLS.keychain.handle
          && !inCart[UPSELLS.keychain.handle]) {
        picks.push({ key: 'keychain', handle: UPSELLS.keychain.handle });
      }
      // Flex shows only on mini-figures pages (not on key-straps pages)
      if (onMiniFigPage
          && currentProduct.handle !== UPSELLS.flex.handle
          && !inCart[UPSELLS.flex.handle]) {
        picks.push({ key: 'flex', handle: UPSELLS.flex.handle });
      }
      return picks;
    });
  }

  function showUpsellAndMaybeAdd(form, addedVariantId) {
    var handle = getCurrentHandle();
    return fetchProduct(handle).then(function (currentProduct) {
      // Skip if the current product itself is one of our upsells (no self-suggest)
      if (isUpsellHandle(currentProduct.handle)) return { decision: 'just-original' };
      return decideUpsells(addedVariantId, currentProduct).then(function (picks) {
        if (!picks.length) return { decision: 'just-original' };

        // Per-offer dismiss: if this exact set of upsells was already dismissed this session, skip the modal
        var sig = offerSignature(picks);
        if (isDismissed(sig)) {
          log('skip: offer already dismissed this session', sig);
          return { decision: 'just-original', offerSignature: sig };
        }

        // Fetch all picks' product data in parallel
        return Promise.all(picks.map(function (p) { return fetchProduct(p.handle).then(function (prod) { return { key: p.key, product: prod }; }); }))
          .then(function (loaded) {
            // Inject cards FIRST, then open modal — avoids flash
            injectModalShell();
            var cardsContainer = modal.querySelector('.sk-upsell-cards');
            cardsContainer.innerHTML = loaded.map(function (l) { return buildCardHTML(l.product, l.key); }).join('');
            wireSwatchClicks();
            openModal();

            track('sk_upsell_shown', {
              original_product: currentProduct.handle,
              upsells_offered: loaded.map(function (l) { return l.product.handle; }).join(','),
              source: isMiniFigurePage() ? 'mini_figures' : (isKeyStrapPage() ? 'key_straps' : 'other')
            });

            return new Promise(function (resolve) {
              var ctaBtn = modal.querySelector('.sk-upsell-cta');
              function cleanup() {
                ctaBtn.removeEventListener('click', onCta);
                modal.removeEventListener('click', onSkip, true);
              }
              function onCta() {
                cleanup();
                var picked = [];
                var pickedHandles = [];
                modal.querySelectorAll('.sk-upsell-item').forEach(function (item) {
                  var cb = item.querySelector('.sk-upsell-checkbox');
                  if (!cb || !cb.checked) return;
                  var vid = parseInt(item.dataset.selectedVariant, 10);
                  if (vid) {
                    picked.push({ id: vid, quantity: 1 });
                    pickedHandles.push(item.dataset.upsellKey);
                  }
                });
                closeModal();
                track('sk_upsell_added', {
                  original_product: currentProduct.handle,
                  upsells_added: pickedHandles.join(','),
                  upsell_count: picked.length
                });
                resolve({ decision: 'add-with-upsells', upsells: picked, offerSignature: sig });
              }
              function onSkip(e) {
                if (!e.target.matches('[data-sk-close]')) return;
                cleanup();
                closeModal();
                track('sk_upsell_skipped', { original_product: currentProduct.handle });
                resolve({ decision: 'just-original', offerSignature: sig });
              }
              ctaBtn.addEventListener('click', onCta);
              modal.addEventListener('click', onSkip, true);
            });
          });
      });
    });
  }

  // STAR KAGUNE add-on slider integration: read toggled .sk-ao-toggle-input items
  function getSkAoItems() {
    var out = [];
    var checks = document.querySelectorAll('.sk-ao-toggle-input:checked');
    for (var i = 0; i < checks.length; i++) {
      var vid = parseInt(checks[i].getAttribute('data-sk-ao-vid'), 10);
      if (vid && !isNaN(vid)) out.push({ id: vid, quantity: 1 });
    }
    return out;
  }

  function batchAdd(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json(); });
  }

  function notifyCartUpdated() {
    // Trigger cart drawer apps (UpCart and others). Fire several common events to be safe.
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:build'));
    document.dispatchEvent(new CustomEvent('cart:added'));
    document.dispatchEvent(new CustomEvent('upcart:cart:refresh'));
    window.dispatchEvent(new CustomEvent('cart:refresh'));
    if (window.UpCart && typeof window.UpCart.openCart === 'function') {
      try { window.UpCart.openCart(); } catch (e) {}
    }
  }

  // -------- analytics --------
  var STATS_KEY = 'sk_upsell_stats_v1';
  function readStats() {
    try { return JSON.parse(localStorage.getItem(STATS_KEY) || '{}'); } catch (e) { return {}; }
  }
  function bumpStat(name, by) {
    try {
      var s = readStats();
      s[name] = (s[name] || 0) + (by || 1);
      s.last_event_at = new Date().toISOString();
      localStorage.setItem(STATS_KEY, JSON.stringify(s));
    } catch (e) {}
  }
  function track(name, params) {
    params = params || {};
    log('TRACK', name, params);
    bumpStat(name, 1);
    // Google Analytics 4 (gtag)
    try { if (window.gtag) window.gtag('event', name, params); } catch (e) {}
    // Universal Analytics fallback (older GA)
    try { if (window.ga) window.ga('send', 'event', 'upsell', name, params.original_product || ''); } catch (e) {}
    // Meta Pixel
    try { if (window.fbq) window.fbq('trackCustom', name, params); } catch (e) {}
    // Shopify Web Pixels (newer)
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, params);
      }
    } catch (e) {}
    // dataLayer (GTM)
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, params)); } catch (e) {}
  }
  // Expose a quick stats reader on the global so admins can run sk_upsell_stats() in console
  try { window.sk_upsell_stats = function () { var s = readStats(); console.table(s); return s; }; } catch (e) {}

  // URL trick: append ?sk_stats=1 to any page on your site to show a stats overlay (no DevTools needed)
  function showStatsOverlay() {
    var s = readStats();
    var shown = s.sk_upsell_shown || 0;
    var added = s.sk_upsell_added || 0;
    var skipped = s.sk_upsell_skipped || 0;
    var rate = shown > 0 ? Math.round(added / shown * 100) : 0;
    var html = [
      '<div style="position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.85);z-index:999999;display:flex;align-items:center;justify-content:center;font-family:monospace;color:#fff" onclick="if(event.target===this)this.remove()">',
      '  <div style="background:#111;padding:32px;border-radius:12px;min-width:320px;border:1px solid #444">',
      '    <h2 style="margin:0 0 16px;font-size:18px;color:#0f0">📊 Upsell Stats (this browser)</h2>',
      '    <div style="display:grid;grid-template-columns:auto auto;gap:8px 24px;font-size:14px">',
      '      <div>Modal shown:</div><div style="text-align:right;color:#0ff;font-weight:bold">' + shown + '</div>',
      '      <div>Upsell added:</div><div style="text-align:right;color:#0f0;font-weight:bold">' + added + '</div>',
      '      <div>Skipped:</div><div style="text-align:right;color:#f80;font-weight:bold">' + skipped + '</div>',
      '      <div>Conversion:</div><div style="text-align:right;color:#fff;font-weight:bold">' + rate + '%</div>',
      '    </div>',
      '    <div style="font-size:11px;color:#888;margin-top:16px;border-top:1px solid #333;padding-top:12px">Last event: ' + (s.last_event_at || '—') + '</div>',
      '    <div style="font-size:11px;color:#666;margin-top:8px">For real customer data, check GA4 / Meta Events Manager.</div>',
      '    <div style="margin-top:16px;display:flex;gap:8px">',
      '      <button onclick="this.closest(\'div[style*=fixed]\').remove()" style="flex:1;padding:8px;background:#333;color:#fff;border:0;border-radius:6px;cursor:pointer">Close</button>',
      '      <button onclick="if(confirm(\'Reset stats?\')){localStorage.removeItem(\'' + STATS_KEY + '\');location.reload()}" style="flex:1;padding:8px;background:#900;color:#fff;border:0;border-radius:6px;cursor:pointer">Reset</button>',
      '    </div>',
      '  </div>',
      '</div>'
    ].join('');
    var div = document.createElement('div');
    div.innerHTML = html;
    document.body.appendChild(div.firstChild);
  }
  if (location.search.indexOf('sk_stats=1') >= 0) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', showStatsOverlay);
    else setTimeout(showStatsOverlay, 100);
  }

  // -------- intercept ATC at the CLICK level (some apps hijack click before submit fires) --------
  function tryInterceptAtcClick(e) {
    // Find ATC submit button
    var btn = e.target.closest && e.target.closest('button[type="submit"][name="add"], button.shop-add-to-cart-button, [data-add-to-cart], button.product-form__submit');
    if (!btn) return;
    var form = btn.closest && btn.closest('form');
    if (!form) return;
    log('click on ATC', { btn: btn.className, formAction: form.getAttribute && form.getAttribute('action'), formType: form.dataset && form.dataset.type });
    runIntercept(form, e);
  }
  document.addEventListener('click', tryInterceptAtcClick, true);

  // -------- intercept ATC submit (backup) --------
  document.addEventListener('submit', function (e) {
    var form = e.target;
    log('submit fired', { tag: form && form.tagName, action: form && form.getAttribute && form.getAttribute('action'), dataType: form && form.dataset && form.dataset.type });
    runIntercept(form, e);
  }, true);

  function runIntercept(form, e) {
    if (!form || form.tagName !== 'FORM') return log('skip: not form');
    if (form.dataset.skUpsellHandled === '1') return log('skip: already handled');
    if (!form.matches('form[action*="/cart/add"]')) return log('skip: not cart/add form');
    if (!form.matches('[data-type="add-to-cart-form"]')) return log('skip: not data-type=add-to-cart-form');
    if (!isTriggerPage()) return log('skip: not minifigure or key-strap page', getCurrentHandle());
    // dismiss check moved to AFTER we know the offer signature

    var idInput = form.querySelector('[name="id"]');
    var qtyInput = form.querySelector('[name="quantity"]');
    var addedVariantId = idInput ? parseInt(idInput.value, 10) : 0;
    if (!addedVariantId) return;
    var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
    var props = getFormProperties(form);

    log('intercepting!', { addedVariantId: addedVariantId, qty: qty });
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

    showUpsellAndMaybeAdd(form, addedVariantId).then(function (result) {
      log('upsell decision', result);
      var firstItem = { id: addedVariantId, quantity: qty };
      if (props) firstItem.properties = props;

      // Mark THIS specific offer as dismissed (so the same offer doesn't re-pop, but a
      // different offer type — e.g. mini-fig combo vs key-strap solo — will still trigger).
      if (result.offerSignature) markDismissed(result.offerSignature);

      if (result.decision === 'just-original') {
        return batchAdd([firstItem].concat(getSkAoItems())).then(notifyCartUpdated);
      }
      var items = [firstItem].concat(result.upsells || []).concat(getSkAoItems());
      return batchAdd(items).then(notifyCartUpdated);
    }).catch(function (err) {
      console.error('[sk-upsell]', err);
      log('error, falling back to plain ATC', err && err.message);
      // Fallback: plain ATC via /cart/add.js so the user isn't stuck
      form.dataset.skUpsellHandled = '1';
      var firstItem = { id: addedVariantId, quantity: qty };
      if (props) firstItem.properties = props;
      batchAdd([firstItem].concat(getSkAoItems())).then(notifyCartUpdated);
    });
  }
})();

